import React, { Component, Fragment } from 'react'
import { wrapper } from 'wbap-core-commit'
import { observer, inject } from 'mobx-react'
import numeral from 'numeral'
import { Charts, Row, Col, Button, PageHeaderLayout } from 'wbap-components'
import styles from './style.less'

const topColResponsiveProps = {
  xs: 24,
  sm: 12,
  md: 12,
  lg: 12,
  xl: 6,
  style: {marginBottom: 24},
}
@inject('UIStore')
@wrapper()
@observer
export default class Page extends Component {
  state = {
    test: true
  }

  constructor (props) {
    super(props)
    this.model = this.props.model
  }

  renderItem () {
    let itemEl = []
    this.model.data.DS_MA.slice().forEach((item) => {
      console.log(this.model.data.DS_NOTE.get(item.FKIND_NAME))
      itemEl.push(
        <Col {...topColResponsiveProps} key={item.FKIND_NAME}>
          <Charts.ChartCard
            bordered={false}
            title={item.FKIND_NAME}
            total={`￥${item.FPRICE_BASE}`}
            footer={<Charts.Field label="刷新时间:" value={item.FNEWTIME}/>}
            contentHeight={46}
          >
          </Charts.ChartCard>
        </Col>
      )
    })
    return itemEl
  }

  renderContent () {
    return (
      <div className={styles.pageHeaderContent}>
        <p>{this.model.data.DS_MA && this.model.data.DS_MA[0] && this.model.data.DS_MA[0]['FREMARK'] || ''}</p>
      </div>
    )
  }

  render () {
    return (
      <PageHeaderLayout title="实时金价" content={this.renderContent()}>
        <Row gutter={24}>
          {this.model.data.DS_MA && this.model.data.DS_MA[0] && this.renderItem()}
        </Row>
      </PageHeaderLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/wbap-unit-app/wbap-dashboard-dailyPrice/page.js